import { t } from 'shared/locale/texts';

export const dateSelectionOptions = [
    { label: t('prepackage.searchType.fixed'), value: 'fixed' },
    { label: t('prepackage.searchType.flexible'), value: 'flexible' },
];
